export default "__VITE_ASSET__BALUmZfY__"